import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectSectionUnitForm } from '../models/project/project-section-unit-form.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectSectionUnitFormService extends RequestService<ProjectSectionUnitForm> {
  static PATH = '/project/section/unit/form';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(
      httpClient,
      ProjectSectionUnitFormService.PATH,
      globalService.debugUrl
    );
  }
}
